import { memo } from 'react'

import { PublicOutlined, BusinessOutlined, DomainOutlined } from '@mui/icons-material'

import { Chip, ChipProps } from '@collaborate-health/uikit'
import { CertificateTypeVisibilityScope } from '@tabeeb/contracts/microservices/swagger-certificate-service'
import { CertificateTypeVisibilityScopeDisplayName } from '../../enums'

const VisibilityScopeToColorMap: Record<CertificateTypeVisibilityScope, ChipProps['color']> = {
  [CertificateTypeVisibilityScope.System]: 'error',
  [CertificateTypeVisibilityScope.Corporation]: 'primary',
  [CertificateTypeVisibilityScope.Tenant]: 'success',
}

const VisibilityScopeToIconMap: Record<CertificateTypeVisibilityScope, ChipProps['icon']> = {
  [CertificateTypeVisibilityScope.System]: <PublicOutlined />,
  [CertificateTypeVisibilityScope.Corporation]: <BusinessOutlined />,
  [CertificateTypeVisibilityScope.Tenant]: <DomainOutlined />,
}

export interface CertificateTypeVisibilityScopeChipProps {
  scope: CertificateTypeVisibilityScope
}

const CertificateTypeVisibilityScopeChip: React.FC<CertificateTypeVisibilityScopeChipProps> = ({ scope }) => {
  const color = VisibilityScopeToColorMap[scope] || 'default'
  const icon = VisibilityScopeToIconMap[scope]

  return <Chip label={CertificateTypeVisibilityScopeDisplayName[scope]} size='small' color={color} icon={icon} />
}

export default memo(CertificateTypeVisibilityScopeChip)

